import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   respondToWorkOrderSignoffRequest,
   RespondToWorkOrderSignoffRequestResponse as RespondToWorkOrderSignoffRequestResponseFromMonolith,
} from '~/monolith-api';

export type RespondToWorkOrderSignoffRequestResponse = Pick<
   RespondToWorkOrderSignoffRequestResponseFromMonolith,
   'username'
>;

const respondToWorkOrderSignoffRequestSchema = z.object({
   entryId: z.number(),
   stepId: z.number(),
   status: z.enum(['approved', 'rejected']),
   password: z.string().optional(),
   token: z.string().optional(),
});
export default createBFFHandlers({
   post: async (req, res) => {
      const { entryId, stepId, status, password, token } =
         respondToWorkOrderSignoffRequestSchema.parse(req.body);

      const monolithClient = getServerSideMonolithClient(req);
      const result = await respondToWorkOrderSignoffRequest(
         entryId,
         stepId,
         status,
         password,
         token,
         {
            apiClient: monolithClient,
         }
      );
      res.status(200).json(result);
   },
});

export const respondToWorkOrderSignoffRequestFromClient = (
   entryId: number,
   stepId: number,
   status: 'approved' | 'rejected',
   password?: string,
   token?: string
): Promise<RespondToWorkOrderSignoffRequestResponse> => {
   return bff()
      .post('/signoffs/respondToWorkOrderSignoffRequest', {
         entryId,
         stepId,
         password,
         status,
         token,
      })
      .then(response => response.data);
};
